import { EsPaymentFee } from "./EsPaymentFee";


export class EsFees {
  total: number;
  feeGrid: EsPaymentFee[];
}
